import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Nav from './Nav';
import { useLocation } from 'react-router-dom';
// import { loadStripe } from '@stripe/stripe-js';
// import { Elements, CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import star2 from '../assets/images/star2.svg';
import questionmark from '../assets/images/questionmark.svg';
import therapeut1 from '../assets/images/therapeut1.png';
import BookingService from '../services/booking.service';
import TherapistService from '../services/therapist.service';
import useApi from '../hooks/useApi';
import useAuth from '../hooks/useAuth';
import MenuHeader from './MenuHeader';
import PromotionService from "../services/promotion.service";
import PromotionUsageService from "../services/promotion_usage.service";
import Header from './Header';
import { useLoading } from '../context/LoadingProvider';
import { endpoints } from '../utils/utils';
import { PhoneInput } from 'react-international-phone';
import { useTranslation } from 'react-i18next';
import { useNotifications } from '../context/NotificationProvider';
import { useTranslatableData } from "../hooks/useTranslatable";
import ComparisonCard from '../Components/ComparisonCard';
import Modal from "react-modal";

import { IconButton } from '@mui/material';
import { usePrompt } from '../hooks/usePrompt';
import PaymentService from '../services/payment.service';
import AuthService from '../services/auth.service';
import { bindEvent, getPusher, initPusher } from "../services/pusher.service";
import { createEventDedupeKey, pushDataLayerEvent } from "../utils/gtmDataLayer";
import {
  buildEcommerceObject,
  buildItemsFromSelectedServices,
  buildUserDataObject,
  calculateValueFromItems,
  computeTaxFromTtc,
} from "../utils/gtmEcommerce";
import {
  extractAllowedPaymentMethods,
  resolvePaymentTypeFromSelectedCard,
} from "../utils/gtmPaymentMethods";
import GtmPaymentMethodModal from "./GtmPaymentMethodModal";
import { buildGtmEventFields } from "../utils/gtmEventFields";
import GuestCheckoutDialog from "./GuestCheckoutDialog";
import { getUserDisplayName } from "../utils/userDisplay";

const EDIT_STEP_PATHS = [
  '/choose-location',
  '/choose-service',
  '/choose-therapist',
  '/payment'
];
const customStyles = {
  content: {
    width: "33%",
    top: "50%",
    padding: "40px",
    left: "50%",
    right: "auto",
    bottom: "auto",
    borderRadius: "10px",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
    maxWidth: "450px",
    margin: "auto",
    textAlign: "center",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};

// const stripePromise = loadStripe('pk_test_51IYwAqDh1V63ycuimBrVJgxaQkDKtUdxkpFmYv38yV8qmiCEeGCKTvlQi7cIAjepUBVaY7Tyx4xSAw8qjBdbB1ze00OanEXi4X'); // Remplacez par votre clé publique Stripe

const formatChf = (value) => {
  if (value == null || value === '') {
    return value;
  }

  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) {
    return value;
  }

  return Number.isInteger(numericValue) ? String(numericValue) : numericValue.toFixed(2);
};

function PaymentForm({ totalPriceCHF }) {
  // const stripe = useStripe();
  const { t, i18n } = useTranslation('payment');
  const navigate = useNavigate();
  const location = useLocation();
  const api = useApi();
  const { auth } = useAuth();
  const { origin_flow, address: rawAddress, duo, totalDuration, totalPrice, selectedServices, selectedTherapist, selectedDate, selectedTime, phone, no_preferences } = location.state || JSON.parse(localStorage.getItem('state') ?? '{}');
  const fromEditBooking = location.state?.fromEditBooking || false;
  const translatedSelectedServices = useTranslatableData(selectedServices);
  const bookingToEdit = JSON.parse(sessionStorage.getItem('bookingToEdit') ?? '{}');
  const address = rawAddress?.street ? rawAddress : rawAddress?.address ? rawAddress.address : {};
  const { lng, lat, zip_code, street, street_number, state, city, state_code, country, country_code } = address || {};
  const [phoneNumber, setPhoneNumber] = useState(auth?.user?.phone || '');
  const [showInput, setShowInput] = useState(false);
  const [showComparison, setShowComparison] = useState(false);
  const [oldBooking, setOldBooking] = useState(null);
  const [newBooking, setNewBooking] = useState(null);
  const translatedOldBooking = useTranslatableData(oldBooking || {});
  const translatedNewBooking = useTranslatableData(newBooking || {});
  const [cards, setCards] = useState([]);
  const [selectedCard, setSelectedCard] = useState(null);
  const [isEditBookingMode, setIsEditBookingMode] = useState(
    sessionStorage.getItem("editBookingMode") === "true" || (location?.state?.fromEditBooking)
  );
  const [editGuardEnabled, setEditGuardEnabled] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [guestCheckoutOpen, setGuestCheckoutOpen] = useState(false);
  const [paymentMethodModalState, setPaymentMethodModalState] = useState({
    open: false,
    methods: [],
    context: null,
  });
  const [availabilityConflictOpen, setAvailabilityConflictOpen] = useState(false);
  const availabilityCheckInFlightRef = useRef(false);
  const lastAvailabilityCheckRef = useRef(0);
  const conflictHandledRef = useRef(false);
  const checkAvailabilityRef = useRef(null);
  const selectedTherapistIdsRef = useRef([]);
  const paymentStartedRef = useRef(false);

  const getTranslation = useCallback((key, fallback) => {
    const translation = t(key);
    return translation === key ? fallback : translation;
  }, [t]);

  const normalizedSelectedTherapists = useMemo(() => {
    if (!selectedTherapist) return [];
    if (Array.isArray(selectedTherapist)) return selectedTherapist;
    return [selectedTherapist];
  }, [selectedTherapist]);

  const selectedTherapistIds = useMemo(() => {
    if (!normalizedSelectedTherapists.length) return [];
    return normalizedSelectedTherapists
      .map((therapist) => (typeof therapist === 'object' ? therapist.id : therapist))
      .map((id) => Number(id))
      .filter((id) => Number.isFinite(id));
  }, [normalizedSelectedTherapists]);

  const selectedProductIds = useMemo(() => {
    if (!Array.isArray(selectedServices)) return [];
    return selectedServices
      .map(service =>
        service?.product?.id ??
        service?.productId ??
        service?.product_id ??
        service?.service?.id ??
        service?.service_id ??
        service?.id
      )
      .filter(Boolean);
  }, [selectedServices]);

  usePrompt(
    isEditBookingMode && editGuardEnabled,
    "Êtes-vous sûr de vouloir quitter la modification ? Vos changements ne seront pas enregistrés.",
    next => EDIT_STEP_PATHS.some(p => next.pathname.startsWith(p)) || next.pathname.startsWith('/commande')
  );

  const normalizeDate = useCallback((value) => {
    if (!value) return null;
    if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
      return value;
    }
    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) return null;
    return parsed.toLocaleDateString('en-CA');
  }, []);

  const openAvailabilityConflict = useCallback(() => {
    if (availabilityConflictOpen) return;
    setAvailabilityConflictOpen(true);
  }, [availabilityConflictOpen]);

  const handleAvailabilityConflictConfirm = useCallback(() => {
    setAvailabilityConflictOpen(false);
    setEditGuardEnabled(false);
    const previousPath = sessionStorage.getItem("previousPath");
    if (previousPath === "/flypro-booking" || origin_flow === "pro") {
      navigate("/flypro-booking");
      return;
    }
    navigate('/choose-therapist');
  }, [navigate, origin_flow]);

  useEffect(() => {
    selectedTherapistIdsRef.current = selectedTherapistIds;
  }, [selectedTherapistIds]);

  const checkAvailability = useCallback(async () => {
    if (paymentStartedRef.current) {
      return;
    }

    if (availabilityConflictOpen || conflictHandledRef.current) {
      return;
    }

    if (!selectedDate || !selectedTime) {
      return;
    }

    if (!selectedProductIds.length || !totalDuration) {
      return;
    }

    if (lng == null || lat == null || !zip_code) {
      return;
    }

    if (no_preferences) {
      return;
    }

    const preferredTherapistIds = selectedTherapistIds.filter((id) => id > 0);
    if (!preferredTherapistIds.length) {
      return;
    }

    if (availabilityCheckInFlightRef.current) {
      return;
    }

    const now = Date.now();
    if (now - lastAvailabilityCheckRef.current < 1500) {
      return;
    }

    lastAvailabilityCheckRef.current = now;
    availabilityCheckInFlightRef.current = true;

    try {
      const normalizedDate = normalizeDate(selectedDate);
      if (!normalizedDate) {
        return;
      }

      const payload = {
        date: normalizedDate,
        time: selectedTime,
        duration: totalDuration,
        lng,
        lat,
        zip_code,
        products: selectedProductIds,
        is_duo: duo,
        status: "ACTIVE",
      };

      if (isEditBookingMode) {
        const storedNew = JSON.parse(sessionStorage.getItem("newBooking") || "{}");
        const storedOld = JSON.parse(sessionStorage.getItem("oldBooking") || "{}");
        const bookingId = storedNew?.id ?? storedOld?.id ?? bookingToEdit?.id ?? 0;
        if (bookingId) {
          payload.booking_id = bookingId;
        }
      }

      let therapistResponse = await TherapistService.store(payload, api, {
        with: "media,ratings,ratings.creator.media,categories",
      });

      if (duo && therapistResponse) {
        const flattened = Array.isArray(therapistResponse)
          ? (therapistResponse.flat ? therapistResponse.flat() : [].concat(...therapistResponse))
          : [].concat(...Object.values(therapistResponse));
        therapistResponse = Array.from(
          new Map(flattened.map((therapist) => [therapist.id, therapist])).values()
        );
      }

      const availableIds = new Set(
        (Array.isArray(therapistResponse) ? therapistResponse : []).map((therapist) => therapist.id)
      );

      const stillAvailable = preferredTherapistIds.every((id) => availableIds.has(id));
      if (!stillAvailable) {
        conflictHandledRef.current = true;
        openAvailabilityConflict();
      }
    } catch (error) {
      console.error("Realtime availability check failed:", error);
    } finally {
      availabilityCheckInFlightRef.current = false;
    }
  }, [
    availabilityConflictOpen,
    selectedDate,
    selectedTime,
    totalDuration,
    lng,
    lat,
    zip_code,
    selectedProductIds,
    selectedTherapistIds,
    no_preferences,
    duo,
    api,
    isEditBookingMode,
    bookingToEdit,
    normalizeDate,
    openAvailabilityConflict,
  ]);

  useEffect(() => {
    checkAvailabilityRef.current = checkAvailability;
  }, [checkAvailability]);

  useEffect(() => {
    initPusher({ token: auth?.accessToken });

    const handler = (data) => {
      const payload =
        typeof data === "string"
          ? (() => {
              try {
                return JSON.parse(data);
              } catch (_) {
                return {};
              }
            })()
          : data || {};

      const key = payload?.key;
      if (key !== "availability" && key !== "calendar") {
        return;
      }

      const eventTherapists = Array.isArray(payload?.payload?.therapist_ids)
        ? payload.payload.therapist_ids.map((id) => Number(id))
        : [];
      const selectedIds = selectedTherapistIdsRef.current.filter((id) => id > 0);

      if (eventTherapists.length && selectedIds.length) {
        const hasOverlap = eventTherapists.some((id) => selectedIds.includes(id));
        if (!hasOverlap) {
          return;
        }
      }

      checkAvailabilityRef.current?.();
    };

    const unbind = bindEvent("public-data", "realtime.data.updated", handler);

    return () => {
      unbind();
    };
  }, [auth?.accessToken]);

  useEffect(() => {
    initPusher({ token: auth?.accessToken });
    const pusher = getPusher();
    if (!pusher) return;

    const handleConnected = () => {
      checkAvailabilityRef.current?.();
    };

    pusher.connection.bind("connected", handleConnected);

    return () => {
      pusher.connection.unbind("connected", handleConnected);
    };
  }, [auth?.accessToken]);

  useEffect(() => {
    const handleOnline = () => {
      checkAvailabilityRef.current?.();
    };

    window.addEventListener("online", handleOnline);

    return () => {
      window.removeEventListener("online", handleOnline);
    };
  }, []);

  const closeCancelModal = () => {
    setShowCancelConfirm(false);
    setEditGuardEnabled(true);
  };

  useEffect(() => {
    if (phone) {
      setPhoneNumber(phone);
    }
  }, []);
  // console.log('location.state', location.state)
  // console.log('totalPrice', totalPrice)
  useEffect(() => {
    const editMode = sessionStorage.getItem("editBookingMode") === "true";
    const oldB = sessionStorage.getItem("oldBooking");
    const newB = sessionStorage.getItem("newBooking");

    if (editMode && oldB && newB) {
      const parsedOld = JSON.parse(oldB);
      const parsedNew = JSON.parse(newB);
      setOldBooking(parsedOld);
      setNewBooking(parsedNew);
      setShowComparison(true);
    }
    if (!selectedServices || selectedServices.length === 0) {
      navigate('/choose-service');
    } else if (!address) {
      navigate('/choose-address');
    }
    if (!selectedTherapist || selectedTherapist.length === 0) {
      navigate('/choose-therapist');
    }
  }, [selectedServices, selectedTherapist, address, navigate]);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const getUsers = async () => {
      try {
        const response = await api.get(endpoints.getProfil);

        console.log(response.data);
        isMounted && setUser(response.data);
      } catch (err) {
        console.error(err);
        sessionStorage.setItem('redirectAfterLogin', '/payment');
        const paymentState = {
          address,
          duo,
          phone,
          totalDuration,
          totalPrice,
          selectedServices,
          selectedTherapist,
          selectedDate,
          selectedTime
        };
        const prev = JSON.parse(sessionStorage.getItem('state') || '{}');
        sessionStorage.setItem('state', JSON.stringify({ ...prev, ...paymentState }));
        //navigate('/login', { state: { from: location }, replace: true });
      }
    }

    getUsers();

    return () => {
      isMounted = false;
      controller.abort();
    }
  }, [])


  const [message, setMessage] = useState('');
  const [promotions, setPromotions] = useState([]);
  const [promoCode, setPromoCode] = useState('');
  const [discountedPrice, setDiscountedPrice] = useState(totalPrice);
  const [alertMessage, setAlertMessage] = useState('');
  const [user, setUser] = useState();
  const [alertMessageTel, setAlertMessageTel] = useState('');

  const isValidPhoneNumber = (number) => {
    const regex = /^[+]?[0-9]{1,4}[-\.\s]?[0-9]{1,4}[-\.\s]?[0-9]{1,4}$/;
    return regex.test(number);
  };

  const handleTelChange = (e) => {

    setPhoneNumber(e);
  };

  const handleSave = () => {
    if (!isValidPhoneNumber(phoneNumber)) {
      setAlertMessageTel("Invalid phone number format");
      const timer = setTimeout(() => setAlertMessageTel(""), 3000);
      return () => clearTimeout(timer);
    }
    setShowInput(false);
    setPhoneNumber(phoneNumber);
    setAlertMessageTel("Phone number saved successfully!");
    setTimeout(() => {
      setAlertMessageTel("");
    }, 3000);
  };

  const fetchPromotions = async () => {
    try {
      const today = new Date().toISOString().split("T")[0];
      const response = await PromotionService.index(
        {
          code: promoCode,
          date_validity: `gte:${today}`,
          is_active: 1,
          with: 'usage',
        },
        api
      );
      // console.log("Promotion:", response[0]);
      if (response?.length > 0) {
        const promotion = response[0];
        if (promotion.extra?.zones_ranges?.length > 0) {
          const zipCodeInt = parseInt(zip_code, 10);
          const isZipCodeValid = promotion.extra.zones_ranges.some(zone => {
            const zoneInt = typeof zone === 'string' ? parseInt(zone, 10) : zone;
            return zoneInt === zipCodeInt;
          });
          if (isZipCodeValid) {
            console.log('Valid zip code found:', zip_code);
          } else {
            setAlertMessage(t("promo.zone_restriction"));
            return;
          }
        }
        if (promotion.all_clients) {
          // console.log("Promotion:", response[0]);
          return response[0];
        } else {
          const clientResponse = await PromotionService.index(
            {
              id: promotion.id,
              with: 'clients,usage',
            },
            api
          );
          // console.log("client Promotion:", clientResponse[0]);
          const clientHasAccess = clientResponse[0]?.clients?.some(client => client.id === auth.user.id);

          if (clientHasAccess) {
            console.log("clientHasAccess", clientHasAccess);
            return clientResponse[0];
          } else {
            setAlertMessage(t("promo.invalid"));
          }
        }
      } else {
        setAlertMessage(t("promo.invalid"));
      }
    } catch (error) {
      console.error("Error fetching promotions", error);
    }
  };

  const resetPromoToFullPrice = (message) => {
    setPromotions(null);
    setDiscountedPrice(totalPrice);
    if (message) {
      setAlertMessage(message);
    }
  };

  const getPromotionUsageLeft = (promotion) => {
    const usedPromotions = (promotion?.usage || []).filter(usage => usage.is_used);
    const userUsage = usedPromotions.filter(
      usage => String(usage.client_id) === String(auth?.user?.id)
    );
    const totalUsage = Number(promotion?.total_usage ?? -1);
    const usagePerCustomer = Number(promotion?.usage_per_customer ?? -1);
    const totalLeft = totalUsage === -1 ? Infinity : Math.max(totalUsage - usedPromotions.length, 0);
    const userLeft = usagePerCustomer === -1 ? Infinity : Math.max(usagePerCustomer - userUsage.length, 0);
    const left = Math.min(totalLeft, userLeft);

    return left === Infinity ? -1 : left;
  };

  const productMatchesPromotion = (product, promotion) => {
    if (!promotion?.product_id) return true;

    return Number(product?.id) === Number(promotion.product_id)
      || Number(product?.parent_id || 0) === Number(promotion.product_id);
  };

  const getPromotionRequiredUses = (promotion) => {
    if (!promotion?.product_id && promotion?.type !== "DURATION") {
      return 1;
    }

    return selectedServices.filter(({ product }) => {
      if (!productMatchesPromotion(product, promotion)) return false;

      if (promotion.type === "DURATION") {
        return Number(promotion.amount) === Number(product?.duration) && !product?.hotel_id;
      }

      return true;
    }).length;
  };

  const handlePromoCodeValidation = async () => {

    const promotions = await fetchPromotions();
    setDiscountedPrice(totalPrice);
    setPromotions(promotions);
    // console.log("promotions timeout:", promotions);


    const promo = promotions?.code === promoCode;
    //console.log("promo:", promo);

    if (promo) {
      const currentDate = new Date();
      const validityDate = new Date(promotions.date_validity);

      if (currentDate <= validityDate) {
        let newPrice = totalPrice;
        let remainingBalance;
        if (promotions.total_usage === -1) {
          console.log("Total usage is unlimited.");
        }

        if (Array.isArray(promotions.usage) && promotions.usage.length >= 0) {
          const usedPromotions = promotions.usage.filter(usage => usage.is_used);

          if (promotions.total_usage !== -1 && usedPromotions.length >= promotions.total_usage) {
            resetPromoToFullPrice(t("promo.usage_limit_reached"));
            return;
          }

          const userUsage = promotions.usage.filter(
            usage => usage.is_used && usage.client_id === auth?.user?.id
          );

          if (promotions.usage_per_customer !== -1 && userUsage.length >= promotions.usage_per_customer) {
            resetPromoToFullPrice(t("promo.user_limit_exceeded"));
            return;
          }
          console.log(promotions)

          if (promotions.type === "FREE_CREDITS") {
            if (promotions.extra['remaining'] === 0) {
              setAlertMessage(t("promo.credit_expired"));
              return;
            }
            const remainingCredits = promotions.usage
              .filter(usage => usage.value > 0);
            if (remainingCredits) {
              promotions.amount = promotions.extra['remaining'];

            }
          }
        }

        let updatedTotalPrice = 0;
        let hasValidProduct = false;
        let durationMismatch = false;
        let remainingUses = getPromotionUsageLeft(promotions);
        const requiredUses = getPromotionRequiredUses(promotions);

        if (requiredUses <= 0) {
          resetPromoToFullPrice(t("promo.invalid_services"));
          return;
        }

        if (remainingUses !== -1 && remainingUses < requiredUses) {
          resetPromoToFullPrice(t("promo.usage_limit_reached"));
          return;
        }

        selectedServices.forEach(service => {
          const product = service.product;
          let newProductPrice = product.price;

          const isValidProduct = productMatchesPromotion(product, promotions);

          if (isValidProduct) {
            hasValidProduct = true;
            if (promotions.type === "DURATION") {
              if (promotions.amount == product?.duration && (remainingUses > 0 || remainingUses === -1)) {
                console.log("is valid duration");
                newProductPrice = 0;
                if (remainingUses !== -1) {
                  remainingUses -= 1;
                }
              } else {
                console.log("is noooo valid duration");
                durationMismatch = true;
                setAlertMessage(t("promo.invalid_duration"));
                newProductPrice = product.price;
              }
            } else if (promotions.type === "FREE") {
              newProductPrice = 0;
            } else if (promotions.type === "PERCENT_OFF") {
              newProductPrice = product.price - (product.price * promotions.amount) / 100;
            } else if (promotions.type === "FLATT_OFF" || promotions.type === "FREE_CREDITS") {
              newProductPrice = Math.max(0, product.price - promotions.amount);
            }
          }

          updatedTotalPrice += newProductPrice;
        });

        if (!hasValidProduct) {
          setAlertMessage(t("promo.invalid_services"));
          return;
        }

        console.log("Updated Total Price:", updatedTotalPrice);


        setDiscountedPrice(updatedTotalPrice);

        if (durationMismatch) {
          setAlertMessage(t("promo.invalid_duration"));
          return;
        };

        setAlertMessage(t("promo.applied_successfully"));

        if (remainingBalance >= 0) {
          console.log(`Remaining balance after discount: ${remainingBalance}`);
        }

      } else {
        setAlertMessage(t("promo.expired"));
      }
    }

    // const timer = setTimeout(() => setAlertMessage(""), 3000);
    // return () => clearTimeout(timer);

  };

  const toMinutes = d => {
    if (d == null) return 0;
    const n = parseInt(d, 10);
    return isNaN(n) ? 0 : n >= 100
      ? (Math.floor(n / 100) * 60) + (n % 100)
      : n;
  };

  const calcDuration = booking => {
    // if (!booking) return 0;

    const list = Array.isArray(booking.products)
      ? booking.products
      : booking.product ? [booking.product] : [];
    return list.reduce((m, p) => m + toMinutes(p?.duration), 0);
  };

  const notify = useNotifications();
  const cguSectionRef = useRef(null);
  const comparisonCguSectionRef = useRef(null);

  const showCguValidationError = (ref) => {
    setShowCguError(true);
    setSubmitting(false);
    notify.warn(t('cgu_required'));

    requestAnimationFrame(() => {
      ref?.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      ref?.current?.querySelector('input[type="checkbox"]')?.focus({ preventScroll: true });
    });
  };

  const handleSubmit = async (event) => {
    event?.preventDefault();
    if (submitting) return;
    setSubmitting(true);

    if (!isCguChecked) {
      showCguValidationError(cguSectionRef);
      return;
    }

    const paymentData = JSON.parse(sessionStorage.getItem('paymentData'));
    const isExtraPay = paymentData && paymentData.amountToPay > 0;
    const trackingUserData = buildUserDataObject({
      user: auth?.user,
      booking: paymentData?.newBooking,
      address: paymentData?.newBooking?.address || address,
      phoneNumber: paymentData?.newBooking?.phone || phoneNumber || auth?.user?.phone,
      emailAddress: auth?.user?.email,
      isConnectedUser: Boolean(auth?.user?.id),
    });
    const finalSubtotal = promotions?.id
      ? discountedPrice
      : selectedServices.reduce((acc, s) => acc + s.product.price, 0);

    const trackingItems = buildItemsFromSelectedServices(selectedServices, {
      address,
    });
    const trackingValue =
      Number.isFinite(Number(finalSubtotal))
        ? Number(finalSubtotal)
        : calculateValueFromItems(trackingItems);
    const trackingCoupon =
      promotions?.id && alertMessage === t("promo.applied_successfully")
        ? promoCode
        : undefined;
    const itemsSignature = trackingItems.map((item) => item.item_id).join(",");

    // Track checkout intent before the payment redirection flow starts.
    try {
      if (trackingItems.length > 0) {
        pushDataLayerEvent(
          "begin_checkout",
          {
            user_data: trackingUserData,
            ...buildGtmEventFields({
              language: i18n.language,
              user: auth?.user,
              flypros: normalizedSelectedTherapists,
            }),
            ecommerce: buildEcommerceObject({
              currency: "CHF",
              value: trackingValue,
              coupon: trackingCoupon,
              tax: computeTaxFromTtc(trackingValue),
              items: trackingItems,
            }),
          },
          {
            dedupeKey: createEventDedupeKey(
              "begin_checkout",
              selectedDate,
              selectedTime,
              trackingValue,
              itemsSignature
            ),
            dedupeTtlMs: 30000,
          }
        );
      }
    } catch (trackingError) {
      console.error("Failed to push begin_checkout event:", trackingError);
    }

    if (isExtraPay) {
      try {
        const duo = selectedTherapist && selectedTherapist.length > 1 ? 1 : 0;
        const updatedPayload = {
          date: `${selectedDate.split('T')[0]} ${selectedTime}`,
          start_before: `${selectedDate.split('T')[0]} ${selectedTime}`,
          duration: parseInt(totalDuration, 10),
          status: 'UPDATED',
          longitude: paymentData.newBooking.address?.lng ?? lng,
          latitude: paymentData.newBooking.address?.lat ?? lat,
          address_id: paymentData.newBooking.address_id || auth?.user?.primary_address_id,
          zip_code: paymentData.newBooking.zip_code || zip_code,
          street: paymentData.newBooking.street || street,
          street_number: paymentData.newBooking.street_number || street_number,
          city: paymentData.newBooking.city || city,
          state: paymentData.newBooking.state || state,
          state_code: paymentData.newBooking.state_code || state_code,
          country: paymentData.newBooking.country || country,
          country_code: paymentData.newBooking.country_code || country_code,
          client_id: auth?.user?.id,
          promocode: paymentData.newBooking.promocode ?? bookingToEdit?.admin_promocode ?? bookingToEdit?.promocode ?? '',
          duo: paymentData.newBooking.duo,
          no_preferences: paymentData.newBooking.no_preferences,

          // Handle product selection for DUO vs SOLO
          product_id: duo
            ? null  // No single product if it's a DUO booking
            : paymentData.newBooking.product?.id ?? selectedServices[0]?.product?.id,

          products: duo
            ? paymentData.newBooking.products.map(p => p.id)
            : [paymentData.newBooking.product?.id ?? selectedServices[0]?.product?.id],

          message: paymentData.newBooking.message || message,
          phone: paymentData.newBooking.phone || phoneNumber,

          therapists: (() => {
            const isEditingSequential = sessionStorage.getItem("editingSequential") === "true";
            if (isEditingSequential) {
              // For sequential bookings, only 1 therapist
              return [paymentData.newBooking.therapists[0].id];
            }
            return duo
              ? paymentData.newBooking.therapists.map(t => t.id)
              : [paymentData.newBooking.therapists[0].id];
          })(),
        };

        const payResp = await BookingService.payDifference(
          {
            booking_id: paymentData.bookingId,
            old_total: paymentData?.oldBooking?.products
              ? paymentData.oldBooking.products.reduce((acc, p) => acc + (p.price || 0), 0)
              : Number(paymentData?.oldBooking?.product?.price ?? paymentData.oldTotal ?? 0),

            new_total: Number(paymentData.newTotal ?? (
              paymentData?.newBooking?.products
                ? paymentData.newBooking.products.reduce((acc, p) => acc + (p.price || 0), 0)
                : Number(paymentData?.newBooking?.product?.price ?? 0)
            )),
            duration: parseInt(totalDuration, 10),
            success_update: updatedPayload,
          },
          api
        );

        //console.log("Payment Successful:", payResp);
        //console.log("Transaction Data:", payResp?.transaction_data);

        const lightboxUrl = payResp?.transaction_data?.data?.payment_lightbox;
        const paymentUrl = payResp?.transaction_data?.data?.payment_url;
        if (!lightboxUrl || !paymentUrl) {
          console.error("Missing Wallee lightbox URLs for extra payment flow.");
          setSubmitting(false);
          return;
        }
        const allowedPaymentMethods = extractAllowedPaymentMethods(payResp?.transaction_data);
        const trackingContext = {
          value: trackingValue,
          coupon: trackingCoupon,
          items: trackingItems,
          userData: trackingUserData,
          dedupeKey: createEventDedupeKey(
            "add_payment_info",
            paymentData?.bookingId || payResp?.transaction_data?.data?.transaction_id || "extra_payment"
          ),
        };
        setEditGuardEnabled(false);
        if (allowedPaymentMethods.length > 0) {
          paymentStartedRef.current = true;
          setPaymentMethodModalState({
            open: true,
            methods: allowedPaymentMethods,
            context: {
              paymentLightboxScript: lightboxUrl,
              paymentUrl,
              trackingContext,
            },
          });
        } else {
          loadLightbox(lightboxUrl, paymentUrl);
        }

        //console.log("Payment Status:", payResp?.transaction_data?.status);
        //console.log("Payment Success:", payResp?.transaction_data?.success);

      } catch (err) {
        console.error("Error during payment or booking update:", err);
      }

      return;
    }


    const duo = selectedTherapist && selectedTherapist.length > 1 ? 1 : 0;
    // Handle booking creation
    const bookingPayload = {
      date: `${selectedDate.split('T')[0]} ${selectedTime}`,
      start_before: `${selectedDate.split('T')[0]} ${selectedTime}`,
      duration: parseInt(totalDuration, 10),
      longitude: lng,
      latitude: lat,
      address_id: auth.user.primary_address_id,
      zip_code,
      no_preferences,
      street,
      street_number,
      city,
      state,
      state_code,
      country,
      country_code,
      client_id: auth.user.id,
      status: 'CREATED',
      total_fare: finalSubtotal,
      subtotal: finalSubtotal,
      promocode: promotions?.id && alertMessage === t("promo.applied_successfully") ? promoCode : '',
      duo: duo,
      product_id: duo ? null : selectedServices[0].product.id,
      products: selectedServices.map(s => s.product.id),
      message: message,
      phone: phoneNumber,
      locale: i18n.language,
      device_type: `${navigator.userAgentData?.platform} - ${navigator.userAgentData?.brands?.[1]?.brand}`,
      device_version: navigator.userAgentData?.brands?.[1]?.version,
      origin_flow: origin_flow,
      therapists: (() => {
        const isEditingSequential = sessionStorage.getItem("editingSequential") === "true";
        if (isEditingSequential) {
          // For sequential bookings, only 1 therapist
          return [Array.isArray(selectedTherapist) ? selectedTherapist[0]?.id : selectedTherapist?.id];
        }
        return duo
          ? selectedTherapist.filter(Boolean).map(t => t.id)
          : [Array.isArray(selectedTherapist) ? selectedTherapist[0]?.id : selectedTherapist?.id];
      })()
    };

    // console.log("Final booking payload", bookingPayload);
    if (selectedCard) {
      bookingPayload.token = selectedCard.token;
    }

    if (finalSubtotal === 0) {
      bookingPayload.offline_payment = true;
    }
    try {
      const resp = await BookingService.store(bookingPayload, api);
      if (finalSubtotal === 0) {
        bookingPayload.offline_payment = true;
        navigate('/commande');
      } else {
        const transactionData = resp?.data?.transaction_data || {};
        const paymentLightboxScript = transactionData?.payment_lightbox;
        const paymentUrl = transactionData?.payment_url;
        if (!paymentLightboxScript || !paymentUrl) {
          console.error("Missing Wallee lightbox URLs for booking payment flow.");
          setSubmitting(false);
          return;
        }
        const allowedPaymentMethods = extractAllowedPaymentMethods(transactionData);
        const dedupeKey = createEventDedupeKey(
          "add_payment_info",
          resp?.data?.id || transactionData?.transaction_id || "booking_payment"
        );
        const trackingContext = {
          value: trackingValue,
          coupon: trackingCoupon,
          items: trackingItems,
          userData: trackingUserData,
          dedupeKey,
        };

        if (selectedCard) {
          pushAddPaymentInfoFromSelection({
            paymentType: resolvePaymentTypeFromSelectedCard(selectedCard),
            ...trackingContext,
          });
          loadLightbox(paymentLightboxScript, paymentUrl);
        } else if (allowedPaymentMethods.length > 0) {
          paymentStartedRef.current = true;
          setPaymentMethodModalState({
            open: true,
            methods: allowedPaymentMethods,
            context: {
              paymentLightboxScript,
              paymentUrl,
              trackingContext,
            },
          });
        } else {
          loadLightbox(paymentLightboxScript, paymentUrl);
        }
      }
    } catch (err) {
      console.error(err);
      const message = err?.response?.data?.message;
      if (err?.response?.status === 422 && message) {
        resetPromoToFullPrice(message);
      }
      setSubmitting(false);
    }
  };

  const loader = useLoading();

  const loadUrl = (paymentUrl) => {
    paymentStartedRef.current = true;
    window.location.replace(paymentUrl);
  }
  const loadLightbox = (paymentLightboxScript, paymentUrl, paymentMethodId = null) => {
    paymentStartedRef.current = true;
    loader.start();
    const script = document.createElement('script');
    script.src = paymentLightboxScript;
    script.async = true;
    script.onload = () => {
      window.LightboxCheckoutHandler.startPayment(paymentMethodId, () => { loader.stop(); loadUrl(paymentUrl) });
    };
    document.body.appendChild(script);
  };

  const pushAddPaymentInfoFromSelection = ({
    paymentType,
    value,
    coupon,
    items,
    userData,
    dedupeKey,
  }) => {
    if (!Array.isArray(items) || items.length === 0) return;

    pushDataLayerEvent(
      "add_payment_info",
      {
        user_data: userData,
        ...buildGtmEventFields({
          language: i18n.language,
          user: auth?.user,
          flypros: normalizedSelectedTherapists,
        }),
        ecommerce: buildEcommerceObject({
          currency: "CHF",
          value,
          coupon,
          tax: computeTaxFromTtc(value),
          paymentType,
          items,
        }),
      },
      {
        dedupeKey,
      }
    );
  };

  const handlePaymentMethodSelection = (method) => {
    const context = paymentMethodModalState.context;
    if (!context) return;
    paymentStartedRef.current = true;

    pushAddPaymentInfoFromSelection({
      paymentType: method?.label,
      ...(context.trackingContext || {}),
    });

    setPaymentMethodModalState({ open: false, methods: [], context: null });
    loadLightbox(context.paymentLightboxScript, context.paymentUrl, method?.id ?? null);
  };

  const closePaymentMethodModal = () => {
    setPaymentMethodModalState({ open: false, methods: [], context: null });
    setSubmitting(false);
  };
  const [handler, setHandler] = useState(null);

  const addMinutesToTime = (time, duration) => {
    const [hours, minutes] = time.split(':').map(Number);
    const date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes + duration);
    return date.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
  };

  const formatSelectedDate = (date) => {
    const options = { day: 'numeric', month: 'short', year: 'numeric' };
    return new Intl.DateTimeFormat(i18n.language === 'fr' ? 'fr-FR' : 'en-US', options).format(new Date(date));
  };

  const previousPathname = sessionStorage.getItem("previousPath");
  const timeSeparator = i18n.language === 'fr' ? 'à' : 'to';
  // sessionStorage.removeItem("previousPath");
  let currentTime = selectedTime;
  console.log('currentTime', currentTime)

  const isSameAddress = (a, b) => {
    if (!a || !b) return false;
    return (
      a.street?.trim() === b.street?.trim() &&
      (a.street_number || '') === (b.street_number || '') &&
      a.zip_code === b.zip_code &&
      a.city === b.city &&
      a.state === b.state &&
      a.country === b.country
    );
  };

  const handleComparisonConfirmation = async () => {
    const bookingId = bookingToEdit?.id || newBooking?.id;
    if (!bookingId || !oldBooking || !newBooking) {
      alert("Données de réservation manquantes.");
      return;
    }

    if (!isCguChecked) {
      showCguValidationError(comparisonCguSectionRef);
      return;
    }

    const getTotal = (booking) => {
      const products = Array.isArray(booking.products)
        ? booking.products
        : [booking.product];
      return products.reduce((sum, p) => sum + (p?.price || 0), 0);
    };

    const oldTotal = getTotal(oldBooking);
    const newTotal = getTotal(newBooking);
    const priceDiff = newTotal - oldTotal;
    const quotePayload = {
      product_id: newBooking.isDuo ? null : newBooking.product?.id,
      duration: parseInt(calcDuration(newBooking), 10),
      status: 'UPDATED',
      date: `${newBooking.date} ${newBooking.time}`,
      start_before: `${newBooking.date} ${newBooking.time}`,
      address_id: oldBooking.address?.id,
      street: newBooking.address?.street ?? oldBooking.address?.street ?? '',
      street_number: newBooking.address?.street_number ?? oldBooking.address?.street_number ?? '',
      zip_code: newBooking.address?.zip_code ?? oldBooking.address?.zip_code ?? '',
      city: newBooking.address?.city ?? oldBooking.address?.city ?? '',
      state: newBooking.address?.state ?? oldBooking.address?.state ?? '',
      country: newBooking.address?.country ?? oldBooking.address?.country ?? 'Switzerland',
      state_code: newBooking.address?.state_code ?? oldBooking.address?.state_code ?? '',
      country_code: newBooking.address?.country_code ?? oldBooking.address?.country_code ?? 'CH',
      latitude: newBooking.address?.lat ?? oldBooking.address?.latitude,
      longitude: newBooking.address?.lng ?? oldBooking.address?.longitude,
      locale: i18n.language,
      products: Array.isArray(newBooking.products)
        ? newBooking.products.map(p => p.id)
        : [newBooking.product.id],
      therapists: (() => {
        const isEditingSequential = sessionStorage.getItem("editingSequential") === "true";
        if (isEditingSequential) {
          return Array.isArray(newBooking.therapists)
            ? [newBooking.therapists[0].id]
            : [newBooking.therapist.id];
        }
        return Array.isArray(newBooking.therapists)
          ? newBooking.therapists.map(t => t.id)
          : [newBooking.therapist.id];
      })(),
    };
    const quoteResponse = await BookingService.editQuote(bookingId, quotePayload, api);
    const quote = quoteResponse?.data;

    if (quote?.action === "UPDATE_ONLY") {
      const updatedBooking = {
        ...oldBooking,
        ...newBooking,
        isDuo: newBooking.isDuo ?? oldBooking.isDuo,
        promocode: newBooking.promocode ?? oldBooking.promocode,
        message: newBooking.message ?? oldBooking.message,
        phone: newBooking.phone ?? oldBooking.phone,
        product_id: newBooking.isDuo
          ? null
          : newBooking.product?.id,
        duration: parseInt(calcDuration(newBooking), 10),
        status: 'UPDATED',
        date: `${newBooking.date} ${newBooking.time}`,
        start_before: `${newBooking.date} ${newBooking.time}`,
        address_id: oldBooking.address?.id,
        street: newBooking.address?.street ?? oldBooking.address?.street ?? '',
        street_number: newBooking.address?.street_number ?? oldBooking.address?.street_number ?? '',
        zip_code: newBooking.address?.zip_code ?? oldBooking.address?.zip_code ?? '',
        city: newBooking.address?.city ?? oldBooking.address?.city ?? '',
        state: newBooking.address?.state ?? oldBooking.address?.state ?? '',
        country: newBooking.address?.country ?? oldBooking.address?.country ?? 'Switzerland',
        state_code: newBooking.address?.state_code ?? oldBooking.address?.state_code ?? '',
        country_code: newBooking.address?.country_code ?? oldBooking.address?.country_code ?? 'CH',
        latitude: newBooking.address?.lat ?? oldBooking.address?.latitude,
        longitude: newBooking.address?.lng ?? oldBooking.address?.longitude,
        locale: i18n.language,
        products: Array.isArray(newBooking.products)
          ? newBooking.products.map(p => p.id)
          : [newBooking.product.id],
        therapists: (() => {
          const isEditingSequential = sessionStorage.getItem("editingSequential") === "true";
          if (isEditingSequential) {
            // For sequential bookings, only 1 therapist
            return Array.isArray(newBooking.therapists)
              ? [newBooking.therapists[0].id]
              : [newBooking.therapist.id];
          }
          return Array.isArray(newBooking.therapists)
            ? newBooking.therapists.map(t => t.id)
            : [newBooking.therapist.id];
        })(),
      };

      try {
        loader.start();
        await BookingService.update(bookingId, updatedBooking, api);
        sessionStorage.clear();
        setEditGuardEnabled(false);
        setIsEditBookingMode(false);
        setTimeout(() => navigate('/commande'), 0);
      } catch (err) {
        console.error(err);
      } finally {
        loader.stop();
      }
      return;
    }

    if (quote?.action === "PAY_DIFFERENCE") {
      sessionStorage.setItem(
        'paymentData',
        JSON.stringify({
          bookingId,
          amountToPay: Math.abs(Number(quote.delta || priceDiff)),
          oldTotal: quote.old_net_total,
          newTotal: quote.new_net_total,
          newBooking,
          quote,
        })
      );
      [
        'editBookingMode',
        'oldBooking',
        'newBooking',
        'bookingToEdit',
        'modificationBookingId',
        'editAddressMode'
      ].forEach(k => sessionStorage.removeItem(k));
      setShowComparison(false);
      handleSubmit(new Event('submit'));
      return;
    }

    if (quote?.action === "REFUND_OR_CREDIT") {
      const refundPayload = { old_total: quote.old_net_total, new_total: quote.new_net_total };
      try {
        loader.start();
        await BookingService.refundDifference(refundPayload, bookingId, api);

        const updatedBooking = {
          id: oldBooking.id,
          date: `${newBooking.date} ${newBooking.time}`,
          start_before: `${newBooking.date} ${newBooking.time}`,
          client_id: auth.user.id,
          product_id: newBooking.isDuo ? null : newBooking.product?.id,
          status: 'UPDATED',
          address_id: newBooking.address.id,
          duration: calcDuration(newBooking),
          refund_type: 'REFUND',
          isDuo: newBooking.isDuo ?? false,
          promocode: newBooking.promocode ?? oldBooking.promocode,
          phone: newBooking.phone ?? oldBooking.phone,
          message: newBooking.message ?? oldBooking.message,
          street: newBooking.address.street ?? '',
          street_number: newBooking.address.street_number ?? '',
          zip_code: newBooking.address.zip_code ?? '',
          city: newBooking.address.city ?? '',
          state: newBooking.address.state ?? '',
          country: newBooking.address.country ?? 'Switzerland',
          state_code: newBooking.address.state_code ?? '',
          country_code: newBooking.address.country_code ?? 'CH',
          latitude: newBooking.address?.lat ?? oldBooking.address?.latitude,
          longitude: newBooking.address?.lng ?? oldBooking.address?.longitude,
          products: Array.isArray(newBooking.products)
            ? newBooking.products.map(p => p.id)
            : [newBooking.product.id],
          therapists: (() => {
            const isEditingSequential = sessionStorage.getItem("editingSequential") === "true";
            if (isEditingSequential) {
              // For sequential bookings, only 1 therapist
              return [newBooking.therapists[0].id].filter(Boolean);
            }
            return newBooking.isDuo
              ? (newBooking.therapists || []).map(t => t.id)
              : [newBooking.therapists[0].id].filter(Boolean);
          })(),
        };

        await BookingService.update(bookingId, updatedBooking, api);
        sessionStorage.clear();

        setShowComparison(false);
        setEditGuardEnabled(false);
        setIsEditBookingMode(false);
        setTimeout(() => {
          navigate("/commande");
        }, 0);
      } catch (err) {
        console.error(err);
      } finally {
        loader.stop();
      }
    }
  };

  const formatTime = (datetime) => {
    if (!datetime) return "N/A";
    const dateObj = new Date(datetime);
    return dateObj.toLocaleTimeString("fr-FR", { hour: '2-digit', minute: '2-digit' });
  };


  const getTherapistName = (booking) => {
    if (booking?.therapist) {
      if (Array.isArray(booking.therapist)) {
        return booking.therapist.filter(t => t != null).map(t => t.firstname).join(", ");
      } else if (booking.therapist.firstname) {
        return booking.therapist.firstname;
      }
    } else if (booking?.therapists && Array.isArray(booking.therapists)) {
      return booking.therapists.filter(t => t != null).map(t => t.firstname).join(", ");
    }
    return "N/A";
  };

  const oldTherapist = getTherapistName(oldBooking);
  const newTherapist = getTherapistName(newBooking);
  const [isCguChecked, setIsCguChecked] = useState(false);
  const [showCguError, setShowCguError] = useState(false);

  const [showCancelConfirm, setShowCancelConfirm] = useState(false);


  const deleteCard = async (token) => {
    try {
      await PaymentService.deleteCard(token, api);
      fetchCards();
    } catch (err) {
      console.error(err);
    }
  }

  const fetchCards = async () => {
    try {
      const response = await AuthService.me({ id: auth.user.id, with: 'cards.brand' }, api);
      setCards(response.user.cards);
      if (response?.user?.cards?.length > 0) {
        setSelectedCard(response.user.cards[0])
      } else {
        setSelectedCard(null);
      }
    } catch (err) {
      console.error(err);
    }
  }

  const handleCardChange = ($event) => {
    if ($event.currentTarget.dataset.id) {
      const card = cards.find((card) => card.id === Number($event.currentTarget.dataset.id));
      if (card) {
        setSelectedCard(card)
      }
    }
    else setSelectedCard(null);
  }

  useEffect(() => {
    fetchCards();
  }, []);

  const urlsFly = {
    cgu: i18n.language === 'fr' 
      ? 'https://flyspa.ch/conditions-generales-utilisation/' 
      : 'https://flyspa.ch/en/general-terms-of-use/',
    privacy: i18n.language === 'fr' 
      ? 'https://flyspa.ch/politique-de-confidentialite/' 
      : 'https://flyspa.ch/en/privacy-policy/'
  };

  const openGuestCheckout = useCallback(() => {
    if (!auth?.user) {
      setGuestCheckoutOpen(true);
    }
  }, [auth?.user]);

  const closeGuestCheckout = useCallback(() => {
    setGuestCheckoutOpen(false);
  }, []);

  const isFlyproPaymentFlow = previousPathname === "/flypro-booking";
  const clientFullName = getUserDisplayName(auth?.user);

  return (
    <div className={isFlyproPaymentFlow ? "flypro-payment-flow" : ""}>
      {isFlyproPaymentFlow ? (
        <>
          <Header className="header--flypro-flow" compactLanguage />
        </>
      ) : (
        <>
          <MenuHeader />
          <Nav page="payment" />
        </>
      )}
      <div className={`content-wrapper payment-page ${isFlyproPaymentFlow ? 'flypro-payment-page' : ''}`}>
        {!showComparison && (
          <div className="content-wrapper duo-pay payment-page__summaries margin-top-min-30">
            {selectedTherapist.map((therapist, therapistIndex) => {
              const therapistServices = translatedSelectedServices.filter(
                (_, serviceIndex) => serviceIndex % selectedTherapist.length === therapistIndex
              );

              let currentTime = selectedTime;

              return (
                <div className="column" key={therapist.id}>
                  <div className="summary-box">
                    <div className="name">
                      <div
                        className="image"
                        style={{
                          backgroundImage: `url(${therapist.media.length ? therapist.media[0].original_url : therapeut1})`,
                        }}
                      ></div>
                      <div className="title">
                        <div className="text-wrapper-2">
                          {therapist.firstname}
                        </div>
                        <div className="rating">
                          <div className="stars">
                            <div className="text-wrapper-3">
                              <img className="https-app" src={star2} alt="Rating" />
                            </div>
                          </div>
                          <div className="text-wrapper-4">{therapist?.extra?.rating}/5</div>
                        </div>
                      </div>
                    </div>
                    <div className="text-wrapper-6" style={{paddingLeft: 0}}>{t('task_resume')}</div>
                    <p className="text-wrapper-5">Date: {formatSelectedDate(selectedDate)}</p>

                    {therapistServices.map((service, indexo) => {
                      const startTime = currentTime;
                      const endTime = addMinutesToTime(startTime, Number(service.product.duration));
                      currentTime = endTime;

                      return (
                        <React.Fragment key={service.id}>
                          <div className="div-2" style={{borderBottom: 0, padding: 0}}>
                            <div className="text-wrapper-6" style={{paddingLeft: 0}}>{indexo == 0 ? t('me') : t('guest') + indexo} - {service?.category?.title} ({service.product.duration}min)</div>
                          </div>

                          <div className="div-2">
                            <p className="text-wrapper-5">
                              {t('duree')}: {service.product.duration}min - {startTime} {timeSeparator} {endTime}
                            </p>
                            <div className="text-wrapper-6" style={{paddingLeft: 0}}>{formatChf(service.product.price)} CHF</div>
                          </div>
                        </React.Fragment>
                      );
                    })}

                    <div className="div-2">
                      <p className="text-wrapper-5">
                        {clientFullName}
                        {clientFullName && (<br/>)}
                        {address?.street} {address?.street_number}
                        <br />
                        {address?.zip_code} {address?.city}
                        <br />
                        {!showInput && phoneNumber}
                        {showInput && (
                          <div className="edit-phone-payload">
                            <PhoneInput
                              type="tel"
                              name="phone"
                              value={phoneNumber}
                              defaultCountry="ch"
                              forceDialCode="true"
                              disableCountryGuess="true"
                              onChange={(phoneNumber) => handleTelChange(phoneNumber)}
                              placeholder={t('enter_new_phone_number')}
                              className="phone-input"
                              inputMode="tel"
                              maxLength={15}
                            />
                            <button
                              onClick={handleSave}
                              className="btn save-button"
                            >
                              {t('save')}
                            </button>
                          </div>
                        )}
                        {alertMessageTel && <div className="alert">{alertMessageTel}</div>}
                      </p>
                    </div>

                    <div className="message-au-flypro">
                      <div className="title-2">
                        <div className="text-wrapper-8 tooltip-wrapper">
                          {t('message_to_flypro')}{" "}
                          <img className="https-app tooltip-icon" src={questionmark} alt="Info" />
                          <div className="tooltip-text">
                            {t('message_mark')}
                          </div>
                        </div>
                      </div>
                      <textarea
                        placeholder={t('example_message')}
                        className="form-message"
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}


        <div className={`column-2 ${showComparison ? 'full' : ''} margin-top-min-30`}>
          {showComparison && (
            <div className="cmp-wrapper">
              <ComparisonCard
                oldBooking={translatedOldBooking}
                newBooking={translatedNewBooking}
                isCguChecked={isCguChecked}
                onCguToggle={setIsCguChecked}
                footer={(
                  <>

                    <div className="total">
                      <div className="price">
                        <div className="list-item-2 list-item-3">
                          <span>{t('total_incl_vat')}</span>
                          <div className="text-wrapper-6">{formatChf(totalPrice)} CHF</div>
                        </div>
                        <div className="form-4 form-with-button">
                          <input
                            type="text"
                            placeholder={t('enter_promo_code')}
                            className="form-5 max-width-50"
                            value={promoCode}
                            onChange={(e) => setPromoCode(e.target.value)}
                          />
                          <button className="form-3" onClick={handlePromoCodeValidation}>
                            {t('validate')}
                          </button>
                        </div>
                        {alertMessage && <div className="alert">{alertMessage}</div>}
                      </div>

                      <div
                        ref={comparisonCguSectionRef}
                        className={`checkbox-2${showCguError ? ' checkbox-2--error' : ''}`}
                      >
                        <input
                          type="checkbox"
                          className="checkbox"
                          id="cgu"
                          checked={isCguChecked}
                          onChange={(e) => {
                            setIsCguChecked(e.target.checked);
                            if (e.target.checked) {
                              setShowCguError(false);
                              setSubmitting(false);
                            }
                          }}
                          aria-invalid={showCguError}
                        />
                        <label htmlFor="cgu" className="accepter-les-CGU-et">
                          <span>{t('payment:accept_terms')} </span>
                          <a href={urlsFly.cgu} style={{ color: '#9aa3ad', textDecoration: 'underline' }} className="text-wrapper-9" target="_blank" rel="noopener noreferrer">conditions générales</a>
                          <span> et la </span>
                          <a href={urlsFly.privacy} style={{ color: '#9aa3ad', textDecoration: 'underline' }} className="text-wrapper-9" target="_blank" rel="noopener noreferrer">politique de confidentialité</a>
                          <span> *</span>
                        </label>
                      </div>

                    </div>
                  </>
                )}
                onConfirm={handleComparisonConfirmation}
                onCancel={() => {
                  setShowCancelConfirm(true);
                  setEditGuardEnabled(false);
                }}
              />
            </div>
          )}

          <Modal
            isOpen={availabilityConflictOpen}
            onRequestClose={handleAvailabilityConflictConfirm}
            shouldCloseOnOverlayClick={false}
            style={{
              content: {
                width: "60%",
                maxWidth: "420px",
                maxHeight: "260px",
                margin: "auto",
                padding: "30px",
                borderRadius: "12px",
                textAlign: "center"
              }
            }}
          >
            <h2>{getTranslation('payment:therapist_unavailable_title', 'flypro unavailable')}</h2>
            <p>{getTranslation('payment:therapist_unavailable', 'The flypro you selected is no longer available for this time slot. Please choose another flypro.')}</p>

            <div style={{ display: "flex", gap: "14px", justifyContent: "center", marginTop: "28px" }}>
              <button
                onClick={handleAvailabilityConflictConfirm}
                style={{
                  padding: "12px 28px",
                  border: "none",
                  borderRadius: "8px",
                  background: "#393d44",
                  color: "#faef9b",
                  fontFamily: "MarcellusRegular",
                  fontSize: "17px",
                  cursor: "pointer"
                }}
              >
                {getTranslation('payment:choose_therapist', 'Choose therapist')}
              </button>
            </div>
          </Modal>

          <Modal
            isOpen={showCancelConfirm}
            onRequestClose={closeCancelModal}
            style={{
              content: {
                width: "60%", maxWidth: "420px", maxHeight: "250px",
                margin: "auto", padding: "30px", borderRadius: "12px", textAlign: "center"
              }
            }}
          >
            <h2>Annuler la modification ?</h2>
            <p>Vos changements en cours seront perdus.<br /><br />Voulez‑vous vraiment quitter ?</p>

            <div style={{ display: "flex", gap: "14px", justifyContent: "center", marginTop: "28px" }}>

              <button
                onClick={closeCancelModal}
                style={{
                  padding: "12px 28px",
                  border: "1.5px solid #393d44",
                  borderRadius: "8px",
                  background: "#fff",
                  color: "#393d44",
                  fontFamily: "MarcellusRegular",
                  fontSize: "17px",
                  cursor: "pointer"
                }}
              >
                Retour
              </button>

              <button
                onClick={() => {
                  sessionStorage.clear();
                  setIsEditBookingMode(false);
                  setShowCancelConfirm(false);
                  navigate('/commande?id=' + (oldBooking?.id ?? ''));
                }}
                style={{
                  padding: "12px 28px",
                  border: "none",
                  borderRadius: "8px",
                  background: "#393d44",
                  color: "#faef9b",
                  fontFamily: "MarcellusRegular",
                  fontSize: "17px",
                  cursor: "pointer"
                }}
              >
                Oui, annuler
              </button>
            </div>
          </Modal>



          {!showComparison && (
            <>
              <div className="total">
                <div className="price">
                  <div className="list-item-2 list-item-3">
                    <span>{t('total_incl_vat')}</span>
                    <div className="text-wrapper-6">{formatChf(totalPrice)} CHF</div>
                  </div>
                  <div className="form-4 form-with-button">
                    <input
                      type="text"
                      placeholder={t('enter_promo_code')}
                      className="form-5"
                      value={promoCode}
                      onChange={(e) => setPromoCode(e.target.value)}
                      onClick={() => {
                        if (!auth?.user) {
                          setAlertMessage("Login for promotions");
                        }
                      }}
                    />
                    <button className="form-3"
                      disabled={!auth?.user}
                      style={{
                        opacity: auth?.user ? 1 : 0.5,
                        cursor: auth?.user ? 'pointer' : 'not-allowed'
                      }}
                      onClick={handlePromoCodeValidation}>
                      {t('validate')}
                    </button>
                  </div>
                  {alertMessage && <div className="alert">{alertMessage}</div>}
                </div>
                {!showComparison && (
                  <div
                    ref={cguSectionRef}
                    className={`checkbox-2${showCguError ? ' checkbox-2--error' : ''}`}
                  >
                    <input
                      type="checkbox"
                      className="checkbox"
                      id="cgu"
                      checked={isCguChecked}
                      onChange={(e) => {
                        setIsCguChecked(e.target.checked);
                        if (e.target.checked){ 
                          setShowCguError(false);
                          setSubmitting(false);}
                      }}
                      aria-invalid={showCguError}
                    />
                    <label htmlFor="cgu" className="accepter-les-CGU-et">
                      <span>{t('payment:accept_terms')} </span>
                      <a href={urlsFly.cgu} style={{ color: '#000', textDecoration: 'underline' }} className="text-wrapper-9" target="_blank" rel="noopener noreferrer">{t('payment:terms_and_conditions')}</a>
                      <span> {t('payment:est')} </span>
                      <a href={urlsFly.privacy} style={{ color: '#000', textDecoration: 'underline' }} className="text-wrapper-9" target="_blank" rel="noopener noreferrer">{t('payment:privacy_policy')}</a>
                      <span> *</span>
                    </label>
                  </div>
                )}
              </div>

              {cards.length > 0 && discountedPrice?.toFixed(2) > 0 && (
                <div className="payment-card-list" style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                  {
                    cards?.map((card, index) => (
                      <div key={index} className="payment-card flex-row align-center" style={{ gap: 20 }}>
                        <div className="flex-row gap-10 align-center" style={{ flex: 1 }}>
                          <img className='brand-icon' src={card.brand.logo} alt='card-brand' width={45} />
                          <div className='flex-column'>
                            <span className='card-holder'>{card.card_holder}</span>
                            <span className='hashed'>{card.hashed.replaceAll('X', '•')}</span>
                            <span className='expiry'>Expire {new Date(card.expiry).toLocaleDateString('en-US', { month: '2-digit', year: '2-digit' })}</span>
                          </div>
                          <IconButton onClick={() => deleteCard(card.token)}><img src='assets/images/icon-trash.svg' alt='delete' /></IconButton>
                        </div>
                        <input type='radio' name='card' style={{ cursor: 'pointer' }} checked={selectedCard === card} onChange={handleCardChange} data-id={card.id}></input>
                      </div>
                    ))
                  }
                  <div className="payment-card flex-row space-between align-center">
                    <span className='card-holder'>{t('newcard')}</span>
                    <input type='radio' name='card' style={{ cursor: 'pointer' }} checked={!selectedCard} onChange={handleCardChange}></input>
                  </div>
                </div>
              )}


              <button
                onClick={auth?.user ? handleSubmit : openGuestCheckout}
                className="button-validation"
                type="button"
                disabled={submitting}
                style={{
                  opacity: submitting ? 0.5 : 1,
                  cursor: submitting ? 'not-allowed' : 'pointer'
                }}
              >
                <span className="button-validation__content">
                  <span className="button-validation__label">{t('pay')}</span>
                  <span className="button-validation__amount">{formatChf(discountedPrice)} CHF{submitting ? " ..." : ""}</span>
                </span>
              </button>
            </>
          )}
        </div>
      </div>
      <GuestCheckoutDialog
        open={guestCheckoutOpen}
        onClose={closeGuestCheckout}
        onRegister={() => navigate('/register')}
        onLogin={() => navigate('/login', { state: { from: location } })}
        title={t('guest_checkout_title')}
        message={t('guest_checkout_message')}
        registerLabel={t('register')}
        loginLabel={t('login')}
      />
      <GtmPaymentMethodModal
        open={paymentMethodModalState.open}
        methods={paymentMethodModalState.methods}
        onSelect={handlePaymentMethodSelection}
        onCancel={closePaymentMethodModal}
      />
    </div>
  );
}

function Payment() {
  return (
    <>
      <PaymentForm totalPriceCHF={120} />
    </>

  );
}

export default Payment;
